<template>
  <div class="page-wrapper">
    <div style="float: left">
      <ButtonGroup vertical>
        <Button v-for="(item,index) in list" :class="{'btn-primary1':type===item.value}" @click.stop="clickType(item.labelImgsVos)" :key="'keyA'+index">
          {{item.label}}
        </Button>
      </ButtonGroup>
    </div>
    <div class="content-right" v-if="dataList.length>0">
      <template v-for="(item,index) in dataList">
        <div class="fileItem">
          <div style="margin-bottom: 10px">
            <img @click.stop="showImg(item.imgUrl)" class="file-img" :src="item.imgUrl" alt="">
          </div>
          <div class="vr_span"><a :href="item.clickUrl" target="_blank">{{item.clickUrl}}</a></div>
        </div>
      </template>
    </div>

    <div v-else style="text-align: center;padding-top: 100px">
      <img :src="noprojectinfo" alt="" >
    </div>
  </div>

</template>
<script>
  import ImgShow from 'components/ImgShow/index'
  import noprojectinfo from '../../../../assets/noprojectinfo.jpg'


  export default {
    name: "PicInfo",
    props: {
      list: {
        type: Array,
        default: []
      }
    },
    components: {
      ImgShow
    },
    data() {
      return {
        dataList:[],
        type: '',
        noprojectinfo:noprojectinfo,
      }
    },
    methods: {
      clickType(value) {
        this.dataList=value
      },
      showImg(src) {
        this.$emit('showimg', src)
      }
    },
    watch: {
      list (){
        if(this.list.length>0){
          if(this.list[0].labelImgsVos){
            this.dataList=this.list[0].labelImgsVos;
          }
        }
      }
    }
  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 200px;
    height: 130px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 130px;
  }

  .fileItem {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    flex-wrap: wrap;

  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 200px;
  }
  .page-wrapper{
    padding-top: 0;
  }
  .vr_span{
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap !important;
    width: 250px;
  }

</style>
